import { generateMetadata, MetaDataEntity } from './utils'

const MetaData: MetaDataEntity = {
  title: 'AviaGames | Privacy Policy Details',
  description:
    "Read Avia's Privacy Policy to learn how we collect, use, and protect your information and ensure your gaming experience stays safe and secure.",
  keywords: ['privacy policy'],
  path: '/privacy-policy',
}

export const PrivacyPolicyMetaData = generateMetadata(MetaData)
